import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_9: FaireProductEntity = {
  token: "legacy_prod_abbott-9",
  type: "product",
  name: "Grey LED Pillar Candle 2x4 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/f044eee76422731eb90ba466b33b37fa77d8be0dc05218b856d3dc2332851e7d.jpeg",
  priceDollars: 8,
  msrpDollars: 16,
  subcategory: "Pillar Candles",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_candles-holders"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
